export class SsoPassThruHttpClient {
    private readonly getToken: () => string;

    constructor(getTokenFn: () => string) {
        this.getToken = getTokenFn;
    }

    public async get<T>(url: string): Promise<T> {
        const token = this.getToken();
        const headers: Record<string, string> = {};
        if (token) {
            headers.Authorization = `Bearer  ${token}`;
        }

        return (await fetch(url, {
            headers,
        })).json();
    }
}
